import type { Action } from 'redux';
import dash_api from '../../../../main/support/dash_api';
import { ReduxAsyncAction } from '../../../services/ReduxAsyncAction';

const TurnOffFlipperFeature = new ReduxAsyncAction<'FLIPPER_TURN_OFF_FEATURE', string, string>('FLIPPER_TURN_OFF_FEATURE');

TurnOffFlipperFeature.registerRequest(async (feature) => {
  await dash_api.post('/v1/flipper/turn-off-feature', { feature });

  return feature;
});

export const FLIPPER_OFF = TurnOffFlipperFeature.actionNamespaceConstants;

export const turnOffFlipperFeature = TurnOffFlipperFeature.request;

export type TurnOffFlipperFeatureResponseAction = Action<typeof FLIPPER_OFF.response> & { data: string };
